<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>
<div class="modal-body mb-12px">
  <div class="repair-desc mb-12px">
    You can check the current {{ ticketType }} process.<br>
    The general {{ ticketType }} status is as follows, and you can check the status of this {{ ticketType }} ticket.
  </div>
  <div class="d-flex justify-content-center">
    <div class="w-100">
      <div class="verti-timeline">
        <div *ngFor="let data of timelineData" [ngClass]="{'left': data.active}" class="timeline-item">
          <div class="timeline-block">
            <div class="timeline-box card">
              <div [ngClass]="{'bg-primary': data.active,
                               'bg-secondary': cancelledStatus.includes(data.status) && data.active,
                               'bg-danger': dangerStatus.includes(data.status) && data.active}"
                   class="card-body t-card">
                <ng-container *ngIf="data.active; else isInActiveTmp">
                  <div class="text-muted">{{ data.description }}</div>
                  <div class="status ml-8px">{{ data.status }}</div>
                </ng-container>
                <ng-template #isInActiveTmp>
                  <div class="status">{{ data.status }}</div>
                  <div class="text-muted ml-8px">{{ data.description }}</div>
                </ng-template>
                <div class="ml-8px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<div class="modal-footer">
</div>-->
